import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-control-tester-final-conclusion-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe],
})
export class ControlTesterFinalConclusionApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Tester Final Conclusion API",
            httpMethod: "POST",
            path: "/controls/testing/advanced/effectiveness/{effectivenessGuid}/automation/workflow/testerfinalconclusion",

            parameters: [
                {
                    name: "effectivenessGuid",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "scoreId",
                    in: "body",
                    paramType: "int",
                    required: true,
                    example: "12",
                },
                {
                    name: "comment",
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "example text",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                },
            ],
        };
    }
}
